import { WidgetType } from '../types/widget-type';

export interface IFiWidgetTypeSettings {
    WidgetType: WidgetType;
    Name: string;
    IconSource: string;
    TextId: string;
}

export const FiWidgetTypeDocumentListing: IFiWidgetTypeSettings = {
    WidgetType: WidgetType.DocumentListing,
    Name: 'DocumentListing',
    IconSource: 'fi-icon-page-listing-widget',
    TextId: 'widget.default_listing_name',
};

export const FiWidgetTypeSiteMap: IFiWidgetTypeSettings = {
    WidgetType: WidgetType.SiteMap,
    Name: 'SiteMap',
    IconSource: 'fa fa-list',
    TextId: 'sitemap.object_name',
};

export const FiWidgetTypeForumListing: IFiWidgetTypeSettings = {
    WidgetType: WidgetType.ForumListing,
    Name: 'ForumListing',
    IconSource: 'fa fa-comments',
    TextId: 'forum.forum_listing',
};

export const FiWidgetTypeNewsFeed: IFiWidgetTypeSettings = {
    WidgetType: WidgetType.NewsFeed,
    Name: 'NewsFeed',
    IconSource: 'fa fa-comments',
    TextId: 'module.news_feed',
};

export const FiWidgetTypeForumFeed: IFiWidgetTypeSettings = {
    WidgetType: WidgetType.ForumFeed,
    Name: 'ForumFeed',
    IconSource: 'fa fa-comments',
    TextId: 'forum.forum_feed',
};

export const FiWidgetTypeAdvancedText: IFiWidgetTypeSettings = {
    WidgetType: WidgetType.AdvancedText,
    Name: 'AdvancedText',
    IconSource: 'fa fa-align-justify',
    TextId: 'widget.default_advanced_text_name',
};

export const FiWidgetTypeFormListing: IFiWidgetTypeSettings = {
    WidgetType: WidgetType.FormListing,
    Name: 'FormListing',
    IconSource: 'fas fa-clipboard-list',
    TextId: 'widget.forms_listing',
};

export const FiWidgetRegistry: { [propName: number]: IFiWidgetTypeSettings } = {
    [FiWidgetTypeDocumentListing.WidgetType]: FiWidgetTypeDocumentListing,
    [FiWidgetTypeSiteMap.WidgetType]: FiWidgetTypeSiteMap,
    [FiWidgetTypeForumListing.WidgetType]: FiWidgetTypeForumListing,
    [FiWidgetTypeNewsFeed.WidgetType]: FiWidgetTypeNewsFeed,
    [FiWidgetTypeForumFeed.WidgetType]: FiWidgetTypeForumFeed,
    [FiWidgetTypeAdvancedText.WidgetType]: FiWidgetTypeAdvancedText,
    [FiWidgetTypeFormListing.WidgetType]: FiWidgetTypeFormListing,
};

export function fiWidgetGetHeaderIcon(widgetType: WidgetType) {
    return FiWidgetRegistry[widgetType].IconSource;
}

export function fiWidgetGetTextId(widgetType: WidgetType) {
    return FiWidgetRegistry[widgetType].TextId;
}
